import { render, staticRenderFns } from "./centered-modal.vue?vue&type=template&id=5d5860d4&scoped=true"
import script from "./centered-modal.vue?vue&type=script&lang=js"
export * from "./centered-modal.vue?vue&type=script&lang=js"
import style0 from "./centered-modal.vue?vue&type=style&index=0&id=5d5860d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5860d4",
  null
  
)

export default component.exports